module.exports = __webpack_public_path__ + "static/media/package_care_10_hours.4c4f8f98.svg";